export enum MedicationOrderType {
    Both = null,
    Generic = 1,
    Brand = 2,
}